// Module
var code = `<!-- ko ifnot: creator.isCreatorDisposed -->
<div data-bind="css: creator.getRootCss(), creatorStyle: creator.themeVariables">
  <div>
    <!-- ko component: { name: 'sv-svg-bundle'} -->
    <!-- /ko -->
  </div>
  <div class="svc-full-container svc-creator__area svc-flex-column" data-bind="css: { 'svc-creator__area--with-banner': !creator.haveCommercialLicense }">
    <div class="svc-flex-row svc-full-container" data-bind="css : { 'svc-creator__side-bar--left': creator.sidebarLocation == 'left' }">
      <div class="svc-flex-column svc-flex-row__element svc-flex-row__element--growing">
        <div class="svc-top-bar">
          <div class="svc-tabbed-menu-wrapper" data-bind="visible: creator.showTabs">
            <!-- ko component: { name: 'svc-tabbed-menu', params: { model: creator.tabbedMenu } } -->
            <!-- /ko -->
          </div>
          <!-- ko if: creator.showToolbar -->
          <div class="svc-toolbar-wrapper" data-bind="visible: creator.showToolbar">
            <!-- ko component: { name: 'sv-action-bar', params: { model: creator.toolbar } } -->
            <!-- /ko -->
          </div>
          <!-- /ko -->
        </div>
        <div class="svc-creator__content-wrapper svc-flex-row" data-bind="css: {'svc-creator__content-wrapper--footer-toolbar' : creator.isMobileView }">
          <div class="svc-creator__content-holder svc-flex-column">
            <!-- ko foreach: creator.tabs -->
            <!-- ko if: \$parent.creator.viewType == id && (\$data.visible === undefined || \$data.visible) -->
            <div class="svc-creator-tab" data-bind="attr: { id: 'scrollableDiv-' + id }, css: { 'svc-creator__toolbox--right': \$parent.creator.toolboxLocation == 'right' }">
              <!-- ko component: { name: componentContent, params: { creator: \$parent.creator, data: data } } -->
              <!-- /ko -->
            </div>
            <!-- /ko -->
            <!-- /ko -->
          </div>
        </div>
        <!-- ko if: creator.isMobileView -->
        <div class="svc-footer-bar">
          <div class="svc-toolbar-wrapper" data-bind="visible: creator.isMobileView">
            <!-- ko component: { name: 'sv-action-bar', params: { model: creator.footerToolbar } } -->
            <!-- /ko -->
          </div>
        </div>
        <!-- /ko -->
      </div>
      <!-- ko if: creator.sidebar -->
      <!-- ko component: { name: 'svc-side-bar', params: { model: creator.sidebar } } -->
      <!-- /ko -->
      <!-- /ko -->
    </div>
    <!-- ko ifnot: creator.haveCommercialLicense -->
    <div class="svc-creator__banner">
      <span class="svc-creator__non-commercial-text" data-bind="html: creator.licenseText"></span>
    </div>
    <!-- /ko -->
    <!-- ko component: { name: 'sv-notifier', params: { notifier: creator.notifier } } -->
    <!-- /ko -->
  </div>
</div>
<!-- /ko -->`;
// Exports
export default code;